import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=1a2b38cc&scoped=true"
import script from "../js/access.js?vue&type=script&lang=js&external"
export * from "../js/access.js?vue&type=script&lang=js&external"
import style0 from "./Access.vue?vue&type=style&index=0&id=1a2b38cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b38cc",
  null
  
)

export default component.exports